// This file is automatically generated. Don't edit it directly.
var HudlDataSchemas;
(function(HudlDataSchemas) {
    let AdEntity;
    (function(AdEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/ad_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = AdEntity.V1_0_0 || (AdEntity.V1_0_0 = {}));
    })(AdEntity = HudlDataSchemas.AdEntity || (HudlDataSchemas.AdEntity = {}));
    let AntiochScenarioData;
    (function(AntiochScenarioData) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/antioch_scenario_data/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = AntiochScenarioData.V1_0_0 || (AntiochScenarioData.V1_0_0 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/antioch_scenario_data/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = AntiochScenarioData.V2_0_0 || (AntiochScenarioData.V2_0_0 = {}));
    })(AntiochScenarioData = HudlDataSchemas.AntiochScenarioData || (HudlDataSchemas.AntiochScenarioData = {}));
    let AntiochTestMetrics;
    (function(AntiochTestMetrics) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/antioch_test_metrics/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = AntiochTestMetrics.V1_0_0 || (AntiochTestMetrics.V1_0_0 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/antioch_test_metrics/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = AntiochTestMetrics.V2_0_0 || (AntiochTestMetrics.V2_0_0 = {}));
    })(AntiochTestMetrics = HudlDataSchemas.AntiochTestMetrics || (HudlDataSchemas.AntiochTestMetrics = {}));
    let AntiochTimeToResults;
    (function(AntiochTimeToResults) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/antioch_time_to_results/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = AntiochTimeToResults.V1_0_0 || (AntiochTimeToResults.V1_0_0 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/antioch_time_to_results/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = AntiochTimeToResults.V2_0_0 || (AntiochTimeToResults.V2_0_0 = {}));
    })(AntiochTimeToResults = HudlDataSchemas.AntiochTimeToResults || (HudlDataSchemas.AntiochTimeToResults = {}));
    let ApplicationEntity;
    (function(ApplicationEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/application_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ApplicationEntity.V1_0_0 || (ApplicationEntity.V1_0_0 = {}));
    })(ApplicationEntity = HudlDataSchemas.ApplicationEntity || (HudlDataSchemas.ApplicationEntity = {}));
    let BroadcastEntity;
    (function(BroadcastEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/broadcast_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = BroadcastEntity.V1_0_0 || (BroadcastEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/broadcast_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = BroadcastEntity.V1_0_1 || (BroadcastEntity.V1_0_1 = {}));
    })(BroadcastEntity = HudlDataSchemas.BroadcastEntity || (HudlDataSchemas.BroadcastEntity = {}));
    let BulkItemEntity;
    (function(BulkItemEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/bulk_item_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = BulkItemEntity.V1_0_0 || (BulkItemEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/bulk_item_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = BulkItemEntity.V1_0_1 || (BulkItemEntity.V1_0_1 = {}));
    })(BulkItemEntity = HudlDataSchemas.BulkItemEntity || (HudlDataSchemas.BulkItemEntity = {}));
    let ConditionEntity;
    (function(ConditionEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/condition_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ConditionEntity.V1_0_0 || (ConditionEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/condition_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ConditionEntity.V1_0_1 || (ConditionEntity.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/condition_entity/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = ConditionEntity.V1_0_2 || (ConditionEntity.V1_0_2 = {}));
    })(ConditionEntity = HudlDataSchemas.ConditionEntity || (HudlDataSchemas.ConditionEntity = {}));
    let ContentFavoriteEvent;
    (function(ContentFavoriteEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/content_favorite_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ContentFavoriteEvent.V1_0_0 || (ContentFavoriteEvent.V1_0_0 = {}));
    })(ContentFavoriteEvent = HudlDataSchemas.ContentFavoriteEvent || (HudlDataSchemas.ContentFavoriteEvent = {}));
    let ContentFilterEvent;
    (function(ContentFilterEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/content_filter_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ContentFilterEvent.V1_0_0 || (ContentFilterEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/content_filter_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ContentFilterEvent.V1_0_1 || (ContentFilterEvent.V1_0_1 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/content_filter_event/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = ContentFilterEvent.V2_0_0 || (ContentFilterEvent.V2_0_0 = {}));
    })(ContentFilterEvent = HudlDataSchemas.ContentFilterEvent || (HudlDataSchemas.ContentFilterEvent = {}));
    let ContentImportExportEvent;
    (function(ContentImportExportEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/content_import_export_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ContentImportExportEvent.V1_0_0 || (ContentImportExportEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/content_import_export_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ContentImportExportEvent.V1_0_1 || (ContentImportExportEvent.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/content_import_export_event/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = ContentImportExportEvent.V1_0_2 || (ContentImportExportEvent.V1_0_2 = {}));
        let V1_0_3;
        (function(V1_0_3) {
            var SCHEMA_URL = V1_0_3.SCHEMA_URL = 'iglu:com.hudl/content_import_export_event/jsonschema/1-0-3';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_3.describe = describe;
        })(V1_0_3 = ContentImportExportEvent.V1_0_3 || (ContentImportExportEvent.V1_0_3 = {}));
        let V1_0_4;
        (function(V1_0_4) {
            var SCHEMA_URL = V1_0_4.SCHEMA_URL = 'iglu:com.hudl/content_import_export_event/jsonschema/1-0-4';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_4.describe = describe;
        })(V1_0_4 = ContentImportExportEvent.V1_0_4 || (ContentImportExportEvent.V1_0_4 = {}));
    })(ContentImportExportEvent = HudlDataSchemas.ContentImportExportEvent || (HudlDataSchemas.ContentImportExportEvent = {}));
    let ContentPlaybackEvent;
    (function(ContentPlaybackEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/content_playback_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ContentPlaybackEvent.V1_0_0 || (ContentPlaybackEvent.V1_0_0 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/content_playback_event/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = ContentPlaybackEvent.V2_0_0 || (ContentPlaybackEvent.V2_0_0 = {}));
        let V3_0_0;
        (function(V3_0_0) {
            var SCHEMA_URL = V3_0_0.SCHEMA_URL = 'iglu:com.hudl/content_playback_event/jsonschema/3-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V3_0_0.describe = describe;
        })(V3_0_0 = ContentPlaybackEvent.V3_0_0 || (ContentPlaybackEvent.V3_0_0 = {}));
        let V3_0_1;
        (function(V3_0_1) {
            var SCHEMA_URL = V3_0_1.SCHEMA_URL = 'iglu:com.hudl/content_playback_event/jsonschema/3-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V3_0_1.describe = describe;
        })(V3_0_1 = ContentPlaybackEvent.V3_0_1 || (ContentPlaybackEvent.V3_0_1 = {}));
        let V3_0_2;
        (function(V3_0_2) {
            var SCHEMA_URL = V3_0_2.SCHEMA_URL = 'iglu:com.hudl/content_playback_event/jsonschema/3-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V3_0_2.describe = describe;
        })(V3_0_2 = ContentPlaybackEvent.V3_0_2 || (ContentPlaybackEvent.V3_0_2 = {}));
        let V3_0_3;
        (function(V3_0_3) {
            var SCHEMA_URL = V3_0_3.SCHEMA_URL = 'iglu:com.hudl/content_playback_event/jsonschema/3-0-3';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V3_0_3.describe = describe;
        })(V3_0_3 = ContentPlaybackEvent.V3_0_3 || (ContentPlaybackEvent.V3_0_3 = {}));
    })(ContentPlaybackEvent = HudlDataSchemas.ContentPlaybackEvent || (HudlDataSchemas.ContentPlaybackEvent = {}));
    let ContentSearchEvent;
    (function(ContentSearchEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/content_search_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ContentSearchEvent.V1_0_0 || (ContentSearchEvent.V1_0_0 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/content_search_event/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = ContentSearchEvent.V2_0_0 || (ContentSearchEvent.V2_0_0 = {}));
        let V2_0_1;
        (function(V2_0_1) {
            var SCHEMA_URL = V2_0_1.SCHEMA_URL = 'iglu:com.hudl/content_search_event/jsonschema/2-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_1.describe = describe;
        })(V2_0_1 = ContentSearchEvent.V2_0_1 || (ContentSearchEvent.V2_0_1 = {}));
        let V2_0_2;
        (function(V2_0_2) {
            var SCHEMA_URL = V2_0_2.SCHEMA_URL = 'iglu:com.hudl/content_search_event/jsonschema/2-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_2.describe = describe;
        })(V2_0_2 = ContentSearchEvent.V2_0_2 || (ContentSearchEvent.V2_0_2 = {}));
    })(ContentSearchEvent = HudlDataSchemas.ContentSearchEvent || (HudlDataSchemas.ContentSearchEvent = {}));
    let ContentShareEvent;
    (function(ContentShareEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/content_share_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ContentShareEvent.V1_0_0 || (ContentShareEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/content_share_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ContentShareEvent.V1_0_1 || (ContentShareEvent.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/content_share_event/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = ContentShareEvent.V1_0_2 || (ContentShareEvent.V1_0_2 = {}));
    })(ContentShareEvent = HudlDataSchemas.ContentShareEvent || (HudlDataSchemas.ContentShareEvent = {}));
    let ContentSortEvent;
    (function(ContentSortEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/content_sort_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ContentSortEvent.V1_0_0 || (ContentSortEvent.V1_0_0 = {}));
    })(ContentSortEvent = HudlDataSchemas.ContentSortEvent || (HudlDataSchemas.ContentSortEvent = {}));
    let ContentUploadDownload;
    (function(ContentUploadDownload) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/content_upload_download/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ContentUploadDownload.V1_0_0 || (ContentUploadDownload.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/content_upload_download/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ContentUploadDownload.V1_0_1 || (ContentUploadDownload.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/content_upload_download/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = ContentUploadDownload.V1_0_2 || (ContentUploadDownload.V1_0_2 = {}));
        let V1_0_3;
        (function(V1_0_3) {
            var SCHEMA_URL = V1_0_3.SCHEMA_URL = 'iglu:com.hudl/content_upload_download/jsonschema/1-0-3';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_3.describe = describe;
        })(V1_0_3 = ContentUploadDownload.V1_0_3 || (ContentUploadDownload.V1_0_3 = {}));
        let V1_0_4;
        (function(V1_0_4) {
            var SCHEMA_URL = V1_0_4.SCHEMA_URL = 'iglu:com.hudl/content_upload_download/jsonschema/1-0-4';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_4.describe = describe;
        })(V1_0_4 = ContentUploadDownload.V1_0_4 || (ContentUploadDownload.V1_0_4 = {}));
    })(ContentUploadDownload = HudlDataSchemas.ContentUploadDownload || (HudlDataSchemas.ContentUploadDownload = {}));
    let ContextEntity;
    (function(ContextEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/context_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ContextEntity.V1_0_0 || (ContextEntity.V1_0_0 = {}));
    })(ContextEntity = HudlDataSchemas.ContextEntity || (HudlDataSchemas.ContextEntity = {}));
    let DashboardEntity;
    (function(DashboardEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/dashboard_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = DashboardEntity.V1_0_0 || (DashboardEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/dashboard_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = DashboardEntity.V1_0_1 || (DashboardEntity.V1_0_1 = {}));
    })(DashboardEntity = HudlDataSchemas.DashboardEntity || (HudlDataSchemas.DashboardEntity = {}));
    let DataDownloadEvent;
    (function(DataDownloadEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/data_download_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = DataDownloadEvent.V1_0_0 || (DataDownloadEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/data_download_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = DataDownloadEvent.V1_0_1 || (DataDownloadEvent.V1_0_1 = {}));
    })(DataDownloadEvent = HudlDataSchemas.DataDownloadEvent || (HudlDataSchemas.DataDownloadEvent = {}));
    let DeepLinkEntity;
    (function(DeepLinkEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/deep_link_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = DeepLinkEntity.V1_0_0 || (DeepLinkEntity.V1_0_0 = {}));
    })(DeepLinkEntity = HudlDataSchemas.DeepLinkEntity || (HudlDataSchemas.DeepLinkEntity = {}));
    let DurationEvent;
    (function(DurationEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/duration_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = DurationEvent.V1_0_0 || (DurationEvent.V1_0_0 = {}));
    })(DurationEvent = HudlDataSchemas.DurationEvent || (HudlDataSchemas.DurationEvent = {}));
    let EventCompetitionEntity;
    (function(EventCompetitionEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/event_competition_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = EventCompetitionEntity.V1_0_0 || (EventCompetitionEntity.V1_0_0 = {}));
    })(EventCompetitionEntity = HudlDataSchemas.EventCompetitionEntity || (HudlDataSchemas.EventCompetitionEntity = {}));
    let EventPlayerEntity;
    (function(EventPlayerEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/event_player_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = EventPlayerEntity.V1_0_0 || (EventPlayerEntity.V1_0_0 = {}));
    })(EventPlayerEntity = HudlDataSchemas.EventPlayerEntity || (HudlDataSchemas.EventPlayerEntity = {}));
    let EventTeamEntity;
    (function(EventTeamEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/event_team_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = EventTeamEntity.V1_0_0 || (EventTeamEntity.V1_0_0 = {}));
    })(EventTeamEntity = HudlDataSchemas.EventTeamEntity || (HudlDataSchemas.EventTeamEntity = {}));
    let GfxApplicationInteractionEvent;
    (function(GfxApplicationInteractionEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/gfx_application_interaction_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = GfxApplicationInteractionEvent.V1_0_0 || (GfxApplicationInteractionEvent.V1_0_0 = {}));
    })(GfxApplicationInteractionEvent = HudlDataSchemas.GfxApplicationInteractionEvent || (HudlDataSchemas.GfxApplicationInteractionEvent = {}));
    let GfxClipEntity;
    (function(GfxClipEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/gfx_clip_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = GfxClipEntity.V1_0_0 || (GfxClipEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/gfx_clip_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = GfxClipEntity.V1_0_1 || (GfxClipEntity.V1_0_1 = {}));
    })(GfxClipEntity = HudlDataSchemas.GfxClipEntity || (HudlDataSchemas.GfxClipEntity = {}));
    let GfxClipItemEffectEvent;
    (function(GfxClipItemEffectEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/gfx_clip_item_effect_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = GfxClipItemEffectEvent.V1_0_0 || (GfxClipItemEffectEvent.V1_0_0 = {}));
    })(GfxClipItemEffectEvent = HudlDataSchemas.GfxClipItemEffectEvent || (HudlDataSchemas.GfxClipItemEffectEvent = {}));
    let GfxPlaylistEntity;
    (function(GfxPlaylistEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/gfx_playlist_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = GfxPlaylistEntity.V1_0_0 || (GfxPlaylistEntity.V1_0_0 = {}));
    })(GfxPlaylistEntity = HudlDataSchemas.GfxPlaylistEntity || (HudlDataSchemas.GfxPlaylistEntity = {}));
    let GslAuthorizationEvent;
    (function(GslAuthorizationEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/gsl_authorization_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = GslAuthorizationEvent.V1_0_0 || (GslAuthorizationEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/gsl_authorization_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = GslAuthorizationEvent.V1_0_1 || (GslAuthorizationEvent.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/gsl_authorization_event/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = GslAuthorizationEvent.V1_0_2 || (GslAuthorizationEvent.V1_0_2 = {}));
        let V1_0_3;
        (function(V1_0_3) {
            var SCHEMA_URL = V1_0_3.SCHEMA_URL = 'iglu:com.hudl/gsl_authorization_event/jsonschema/1-0-3';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_3.describe = describe;
        })(V1_0_3 = GslAuthorizationEvent.V1_0_3 || (GslAuthorizationEvent.V1_0_3 = {}));
        let V1_0_4;
        (function(V1_0_4) {
            var SCHEMA_URL = V1_0_4.SCHEMA_URL = 'iglu:com.hudl/gsl_authorization_event/jsonschema/1-0-4';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_4.describe = describe;
        })(V1_0_4 = GslAuthorizationEvent.V1_0_4 || (GslAuthorizationEvent.V1_0_4 = {}));
    })(GslAuthorizationEvent = HudlDataSchemas.GslAuthorizationEvent || (HudlDataSchemas.GslAuthorizationEvent = {}));
    let GslCompetitionEntity;
    (function(GslCompetitionEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/gsl_competition_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = GslCompetitionEntity.V1_0_0 || (GslCompetitionEntity.V1_0_0 = {}));
    })(GslCompetitionEntity = HudlDataSchemas.GslCompetitionEntity || (HudlDataSchemas.GslCompetitionEntity = {}));
    let GslCompetitionPeriodEntity;
    (function(GslCompetitionPeriodEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/gsl_competition_period_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = GslCompetitionPeriodEntity.V1_0_0 || (GslCompetitionPeriodEntity.V1_0_0 = {}));
    })(GslCompetitionPeriodEntity = HudlDataSchemas.GslCompetitionPeriodEntity || (HudlDataSchemas.GslCompetitionPeriodEntity = {}));
    let GslFixtureEntity;
    (function(GslFixtureEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/gsl_fixture_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = GslFixtureEntity.V1_0_0 || (GslFixtureEntity.V1_0_0 = {}));
    })(GslFixtureEntity = HudlDataSchemas.GslFixtureEntity || (HudlDataSchemas.GslFixtureEntity = {}));
    let GslPlayerEntity;
    (function(GslPlayerEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/gsl_player_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = GslPlayerEntity.V1_0_0 || (GslPlayerEntity.V1_0_0 = {}));
    })(GslPlayerEntity = HudlDataSchemas.GslPlayerEntity || (HudlDataSchemas.GslPlayerEntity = {}));
    let GslTeamEntity;
    (function(GslTeamEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/gsl_team_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = GslTeamEntity.V1_0_0 || (GslTeamEntity.V1_0_0 = {}));
    })(GslTeamEntity = HudlDataSchemas.GslTeamEntity || (HudlDataSchemas.GslTeamEntity = {}));
    let HeartbeatEvent;
    (function(HeartbeatEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/heartbeat_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = HeartbeatEvent.V1_0_0 || (HeartbeatEvent.V1_0_0 = {}));
    })(HeartbeatEvent = HudlDataSchemas.HeartbeatEvent || (HudlDataSchemas.HeartbeatEvent = {}));
    let InsightClipEntity;
    (function(InsightClipEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/insight_clip_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = InsightClipEntity.V1_0_0 || (InsightClipEntity.V1_0_0 = {}));
    })(InsightClipEntity = HudlDataSchemas.InsightClipEntity || (HudlDataSchemas.InsightClipEntity = {}));
    let InsightConditionEntity;
    (function(InsightConditionEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/insight_condition_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = InsightConditionEntity.V1_0_0 || (InsightConditionEntity.V1_0_0 = {}));
    })(InsightConditionEntity = HudlDataSchemas.InsightConditionEntity || (HudlDataSchemas.InsightConditionEntity = {}));
    let InsightDashboardEntity;
    (function(InsightDashboardEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/insight_dashboard_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = InsightDashboardEntity.V1_0_0 || (InsightDashboardEntity.V1_0_0 = {}));
    })(InsightDashboardEntity = HudlDataSchemas.InsightDashboardEntity || (HudlDataSchemas.InsightDashboardEntity = {}));
    let InsightFixtureEntity;
    (function(InsightFixtureEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/insight_fixture_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = InsightFixtureEntity.V1_0_0 || (InsightFixtureEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/insight_fixture_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = InsightFixtureEntity.V1_0_1 || (InsightFixtureEntity.V1_0_1 = {}));
    })(InsightFixtureEntity = HudlDataSchemas.InsightFixtureEntity || (HudlDataSchemas.InsightFixtureEntity = {}));
    let InsightPlaylistEntity;
    (function(InsightPlaylistEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/insight_playlist_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = InsightPlaylistEntity.V1_0_0 || (InsightPlaylistEntity.V1_0_0 = {}));
    })(InsightPlaylistEntity = HudlDataSchemas.InsightPlaylistEntity || (HudlDataSchemas.InsightPlaylistEntity = {}));
    let InsightProjectEntity;
    (function(InsightProjectEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/insight_project_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = InsightProjectEntity.V1_0_0 || (InsightProjectEntity.V1_0_0 = {}));
    })(InsightProjectEntity = HudlDataSchemas.InsightProjectEntity || (HudlDataSchemas.InsightProjectEntity = {}));
    let InsightVideoEntity;
    (function(InsightVideoEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/insight_video_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = InsightVideoEntity.V1_0_0 || (InsightVideoEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/insight_video_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = InsightVideoEntity.V1_0_1 || (InsightVideoEntity.V1_0_1 = {}));
    })(InsightVideoEntity = HudlDataSchemas.InsightVideoEntity || (HudlDataSchemas.InsightVideoEntity = {}));
    let InsightWidgetEntity;
    (function(InsightWidgetEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/insight_widget_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = InsightWidgetEntity.V1_0_0 || (InsightWidgetEntity.V1_0_0 = {}));
    })(InsightWidgetEntity = HudlDataSchemas.InsightWidgetEntity || (HudlDataSchemas.InsightWidgetEntity = {}));
    let LicenseEntity;
    (function(LicenseEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/license_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = LicenseEntity.V1_0_0 || (LicenseEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/license_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = LicenseEntity.V1_0_1 || (LicenseEntity.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/license_entity/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = LicenseEntity.V1_0_2 || (LicenseEntity.V1_0_2 = {}));
    })(LicenseEntity = HudlDataSchemas.LicenseEntity || (HudlDataSchemas.LicenseEntity = {}));
    let ModelRunEntity;
    (function(ModelRunEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/model_run_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ModelRunEntity.V1_0_0 || (ModelRunEntity.V1_0_0 = {}));
    })(ModelRunEntity = HudlDataSchemas.ModelRunEntity || (HudlDataSchemas.ModelRunEntity = {}));
    let ModuleEntity;
    (function(ModuleEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/module_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ModuleEntity.V1_0_0 || (ModuleEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/module_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ModuleEntity.V1_0_1 || (ModuleEntity.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/module_entity/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = ModuleEntity.V1_0_2 || (ModuleEntity.V1_0_2 = {}));
        let V1_0_3;
        (function(V1_0_3) {
            var SCHEMA_URL = V1_0_3.SCHEMA_URL = 'iglu:com.hudl/module_entity/jsonschema/1-0-3';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_3.describe = describe;
        })(V1_0_3 = ModuleEntity.V1_0_3 || (ModuleEntity.V1_0_3 = {}));
    })(ModuleEntity = HudlDataSchemas.ModuleEntity || (HudlDataSchemas.ModuleEntity = {}));
    let MonitorEntity;
    (function(MonitorEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/monitor_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = MonitorEntity.V1_0_0 || (MonitorEntity.V1_0_0 = {}));
    })(MonitorEntity = HudlDataSchemas.MonitorEntity || (HudlDataSchemas.MonitorEntity = {}));
    let ObjectActivateDeactivateEvent;
    (function(ObjectActivateDeactivateEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/object_activate_deactivate_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ObjectActivateDeactivateEvent.V1_0_0 || (ObjectActivateDeactivateEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/object_activate_deactivate_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ObjectActivateDeactivateEvent.V1_0_1 || (ObjectActivateDeactivateEvent.V1_0_1 = {}));
    })(ObjectActivateDeactivateEvent = HudlDataSchemas.ObjectActivateDeactivateEvent || (HudlDataSchemas.ObjectActivateDeactivateEvent = {}));
    let ObjectChangeEvent;
    (function(ObjectChangeEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/object_change_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ObjectChangeEvent.V1_0_0 || (ObjectChangeEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/object_change_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ObjectChangeEvent.V1_0_1 || (ObjectChangeEvent.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/object_change_event/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = ObjectChangeEvent.V1_0_2 || (ObjectChangeEvent.V1_0_2 = {}));
        let V1_0_3;
        (function(V1_0_3) {
            var SCHEMA_URL = V1_0_3.SCHEMA_URL = 'iglu:com.hudl/object_change_event/jsonschema/1-0-3';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_3.describe = describe;
        })(V1_0_3 = ObjectChangeEvent.V1_0_3 || (ObjectChangeEvent.V1_0_3 = {}));
        let V1_0_4;
        (function(V1_0_4) {
            var SCHEMA_URL = V1_0_4.SCHEMA_URL = 'iglu:com.hudl/object_change_event/jsonschema/1-0-4';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_4.describe = describe;
        })(V1_0_4 = ObjectChangeEvent.V1_0_4 || (ObjectChangeEvent.V1_0_4 = {}));
        let V1_0_5;
        (function(V1_0_5) {
            var SCHEMA_URL = V1_0_5.SCHEMA_URL = 'iglu:com.hudl/object_change_event/jsonschema/1-0-5';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_5.describe = describe;
        })(V1_0_5 = ObjectChangeEvent.V1_0_5 || (ObjectChangeEvent.V1_0_5 = {}));
        let V1_0_6;
        (function(V1_0_6) {
            var SCHEMA_URL = V1_0_6.SCHEMA_URL = 'iglu:com.hudl/object_change_event/jsonschema/1-0-6';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_6.describe = describe;
        })(V1_0_6 = ObjectChangeEvent.V1_0_6 || (ObjectChangeEvent.V1_0_6 = {}));
        let V1_0_7;
        (function(V1_0_7) {
            var SCHEMA_URL = V1_0_7.SCHEMA_URL = 'iglu:com.hudl/object_change_event/jsonschema/1-0-7';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_7.describe = describe;
        })(V1_0_7 = ObjectChangeEvent.V1_0_7 || (ObjectChangeEvent.V1_0_7 = {}));
    })(ObjectChangeEvent = HudlDataSchemas.ObjectChangeEvent || (HudlDataSchemas.ObjectChangeEvent = {}));
    let ObjectCreationEvent;
    (function(ObjectCreationEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/object_creation_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ObjectCreationEvent.V1_0_0 || (ObjectCreationEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/object_creation_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ObjectCreationEvent.V1_0_1 || (ObjectCreationEvent.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/object_creation_event/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = ObjectCreationEvent.V1_0_2 || (ObjectCreationEvent.V1_0_2 = {}));
        let V1_0_3;
        (function(V1_0_3) {
            var SCHEMA_URL = V1_0_3.SCHEMA_URL = 'iglu:com.hudl/object_creation_event/jsonschema/1-0-3';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_3.describe = describe;
        })(V1_0_3 = ObjectCreationEvent.V1_0_3 || (ObjectCreationEvent.V1_0_3 = {}));
        let V1_0_4;
        (function(V1_0_4) {
            var SCHEMA_URL = V1_0_4.SCHEMA_URL = 'iglu:com.hudl/object_creation_event/jsonschema/1-0-4';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_4.describe = describe;
        })(V1_0_4 = ObjectCreationEvent.V1_0_4 || (ObjectCreationEvent.V1_0_4 = {}));
        let V1_0_5;
        (function(V1_0_5) {
            var SCHEMA_URL = V1_0_5.SCHEMA_URL = 'iglu:com.hudl/object_creation_event/jsonschema/1-0-5';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_5.describe = describe;
        })(V1_0_5 = ObjectCreationEvent.V1_0_5 || (ObjectCreationEvent.V1_0_5 = {}));
    })(ObjectCreationEvent = HudlDataSchemas.ObjectCreationEvent || (HudlDataSchemas.ObjectCreationEvent = {}));
    let ObjectOpenCloseEvent;
    (function(ObjectOpenCloseEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/object_open_close_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ObjectOpenCloseEvent.V1_0_0 || (ObjectOpenCloseEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/object_open_close_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ObjectOpenCloseEvent.V1_0_1 || (ObjectOpenCloseEvent.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/object_open_close_event/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = ObjectOpenCloseEvent.V1_0_2 || (ObjectOpenCloseEvent.V1_0_2 = {}));
        let V1_0_3;
        (function(V1_0_3) {
            var SCHEMA_URL = V1_0_3.SCHEMA_URL = 'iglu:com.hudl/object_open_close_event/jsonschema/1-0-3';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_3.describe = describe;
        })(V1_0_3 = ObjectOpenCloseEvent.V1_0_3 || (ObjectOpenCloseEvent.V1_0_3 = {}));
        let V1_0_4;
        (function(V1_0_4) {
            var SCHEMA_URL = V1_0_4.SCHEMA_URL = 'iglu:com.hudl/object_open_close_event/jsonschema/1-0-4';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_4.describe = describe;
        })(V1_0_4 = ObjectOpenCloseEvent.V1_0_4 || (ObjectOpenCloseEvent.V1_0_4 = {}));
        let V1_0_5;
        (function(V1_0_5) {
            var SCHEMA_URL = V1_0_5.SCHEMA_URL = 'iglu:com.hudl/object_open_close_event/jsonschema/1-0-5';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_5.describe = describe;
        })(V1_0_5 = ObjectOpenCloseEvent.V1_0_5 || (ObjectOpenCloseEvent.V1_0_5 = {}));
        let V1_0_6;
        (function(V1_0_6) {
            var SCHEMA_URL = V1_0_6.SCHEMA_URL = 'iglu:com.hudl/object_open_close_event/jsonschema/1-0-6';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_6.describe = describe;
        })(V1_0_6 = ObjectOpenCloseEvent.V1_0_6 || (ObjectOpenCloseEvent.V1_0_6 = {}));
        let V1_0_7;
        (function(V1_0_7) {
            var SCHEMA_URL = V1_0_7.SCHEMA_URL = 'iglu:com.hudl/object_open_close_event/jsonschema/1-0-7';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_7.describe = describe;
        })(V1_0_7 = ObjectOpenCloseEvent.V1_0_7 || (ObjectOpenCloseEvent.V1_0_7 = {}));
    })(ObjectOpenCloseEvent = HudlDataSchemas.ObjectOpenCloseEvent || (HudlDataSchemas.ObjectOpenCloseEvent = {}));
    let ObjectResizeEvent;
    (function(ObjectResizeEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/object_resize_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ObjectResizeEvent.V1_0_0 || (ObjectResizeEvent.V1_0_0 = {}));
    })(ObjectResizeEvent = HudlDataSchemas.ObjectResizeEvent || (HudlDataSchemas.ObjectResizeEvent = {}));
    let ObjectRunEvent;
    (function(ObjectRunEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/object_run_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ObjectRunEvent.V1_0_0 || (ObjectRunEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/object_run_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ObjectRunEvent.V1_0_1 || (ObjectRunEvent.V1_0_1 = {}));
    })(ObjectRunEvent = HudlDataSchemas.ObjectRunEvent || (HudlDataSchemas.ObjectRunEvent = {}));
    let ObjectSaveEvent;
    (function(ObjectSaveEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/object_save_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ObjectSaveEvent.V1_0_0 || (ObjectSaveEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/object_save_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = ObjectSaveEvent.V1_0_1 || (ObjectSaveEvent.V1_0_1 = {}));
    })(ObjectSaveEvent = HudlDataSchemas.ObjectSaveEvent || (HudlDataSchemas.ObjectSaveEvent = {}));
    let OriginDestinationEvent;
    (function(OriginDestinationEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/origin_destination_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = OriginDestinationEvent.V1_0_0 || (OriginDestinationEvent.V1_0_0 = {}));
    })(OriginDestinationEvent = HudlDataSchemas.OriginDestinationEvent || (HudlDataSchemas.OriginDestinationEvent = {}));
    let PageEntity;
    (function(PageEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/page_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = PageEntity.V1_0_0 || (PageEntity.V1_0_0 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/page_entity/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = PageEntity.V2_0_0 || (PageEntity.V2_0_0 = {}));
        let V2_0_1;
        (function(V2_0_1) {
            var SCHEMA_URL = V2_0_1.SCHEMA_URL = 'iglu:com.hudl/page_entity/jsonschema/2-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_1.describe = describe;
        })(V2_0_1 = PageEntity.V2_0_1 || (PageEntity.V2_0_1 = {}));
        let V2_0_2;
        (function(V2_0_2) {
            var SCHEMA_URL = V2_0_2.SCHEMA_URL = 'iglu:com.hudl/page_entity/jsonschema/2-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_2.describe = describe;
        })(V2_0_2 = PageEntity.V2_0_2 || (PageEntity.V2_0_2 = {}));
    })(PageEntity = HudlDataSchemas.PageEntity || (HudlDataSchemas.PageEntity = {}));
    let PlaylistClipEntity;
    (function(PlaylistClipEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/playlist_clip_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = PlaylistClipEntity.V1_0_0 || (PlaylistClipEntity.V1_0_0 = {}));
    })(PlaylistClipEntity = HudlDataSchemas.PlaylistClipEntity || (HudlDataSchemas.PlaylistClipEntity = {}));
    let PlaylistEntity;
    (function(PlaylistEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/playlist_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = PlaylistEntity.V1_0_0 || (PlaylistEntity.V1_0_0 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/playlist_entity/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = PlaylistEntity.V2_0_0 || (PlaylistEntity.V2_0_0 = {}));
        let V2_0_1;
        (function(V2_0_1) {
            var SCHEMA_URL = V2_0_1.SCHEMA_URL = 'iglu:com.hudl/playlist_entity/jsonschema/2-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_1.describe = describe;
        })(V2_0_1 = PlaylistEntity.V2_0_1 || (PlaylistEntity.V2_0_1 = {}));
    })(PlaylistEntity = HudlDataSchemas.PlaylistEntity || (HudlDataSchemas.PlaylistEntity = {}));
    let PropertyEntity;
    (function(PropertyEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/property_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = PropertyEntity.V1_0_0 || (PropertyEntity.V1_0_0 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/property_entity/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = PropertyEntity.V2_0_0 || (PropertyEntity.V2_0_0 = {}));
    })(PropertyEntity = HudlDataSchemas.PropertyEntity || (HudlDataSchemas.PropertyEntity = {}));
    let QaTestResultEvent;
    (function(QaTestResultEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/qa_test_result_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = QaTestResultEvent.V1_0_0 || (QaTestResultEvent.V1_0_0 = {}));
    })(QaTestResultEvent = HudlDataSchemas.QaTestResultEvent || (HudlDataSchemas.QaTestResultEvent = {}));
    let RelationshipEntity;
    (function(RelationshipEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/relationship_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = RelationshipEntity.V1_0_0 || (RelationshipEntity.V1_0_0 = {}));
    })(RelationshipEntity = HudlDataSchemas.RelationshipEntity || (HudlDataSchemas.RelationshipEntity = {}));
    let ReportEntity;
    (function(ReportEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/report_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ReportEntity.V1_0_0 || (ReportEntity.V1_0_0 = {}));
    })(ReportEntity = HudlDataSchemas.ReportEntity || (HudlDataSchemas.ReportEntity = {}));
    let SyntheticDeEvent;
    (function(SyntheticDeEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/synthetic_de_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = SyntheticDeEvent.V1_0_0 || (SyntheticDeEvent.V1_0_0 = {}));
    })(SyntheticDeEvent = HudlDataSchemas.SyntheticDeEvent || (HudlDataSchemas.SyntheticDeEvent = {}));
    let TeamEntity;
    (function(TeamEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/team_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = TeamEntity.V1_0_0 || (TeamEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/team_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = TeamEntity.V1_0_1 || (TeamEntity.V1_0_1 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/team_entity/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = TeamEntity.V2_0_0 || (TeamEntity.V2_0_0 = {}));
        let V3_0_0;
        (function(V3_0_0) {
            var SCHEMA_URL = V3_0_0.SCHEMA_URL = 'iglu:com.hudl/team_entity/jsonschema/3-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V3_0_0.describe = describe;
        })(V3_0_0 = TeamEntity.V3_0_0 || (TeamEntity.V3_0_0 = {}));
        let V4_0_0;
        (function(V4_0_0) {
            var SCHEMA_URL = V4_0_0.SCHEMA_URL = 'iglu:com.hudl/team_entity/jsonschema/4-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V4_0_0.describe = describe;
        })(V4_0_0 = TeamEntity.V4_0_0 || (TeamEntity.V4_0_0 = {}));
        let V5_0_0;
        (function(V5_0_0) {
            var SCHEMA_URL = V5_0_0.SCHEMA_URL = 'iglu:com.hudl/team_entity/jsonschema/5-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V5_0_0.describe = describe;
        })(V5_0_0 = TeamEntity.V5_0_0 || (TeamEntity.V5_0_0 = {}));
    })(TeamEntity = HudlDataSchemas.TeamEntity || (HudlDataSchemas.TeamEntity = {}));
    let UnifiedProductInsightsModuleEvent;
    (function(UnifiedProductInsightsModuleEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/unified_product_insights_module_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = UnifiedProductInsightsModuleEvent.V1_0_0 || (UnifiedProductInsightsModuleEvent.V1_0_0 = {}));
    })(UnifiedProductInsightsModuleEvent = HudlDataSchemas.UnifiedProductInsightsModuleEvent || (HudlDataSchemas.UnifiedProductInsightsModuleEvent = {}));
    let UnifiedProductPlaylistsEvent;
    (function(UnifiedProductPlaylistsEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/unified_product_playlists_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = UnifiedProductPlaylistsEvent.V1_0_0 || (UnifiedProductPlaylistsEvent.V1_0_0 = {}));
    })(UnifiedProductPlaylistsEvent = HudlDataSchemas.UnifiedProductPlaylistsEvent || (HudlDataSchemas.UnifiedProductPlaylistsEvent = {}));
    let UserEntity;
    (function(UserEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/user_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = UserEntity.V1_0_0 || (UserEntity.V1_0_0 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/user_entity/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = UserEntity.V2_0_0 || (UserEntity.V2_0_0 = {}));
        let V2_0_1;
        (function(V2_0_1) {
            var SCHEMA_URL = V2_0_1.SCHEMA_URL = 'iglu:com.hudl/user_entity/jsonschema/2-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_1.describe = describe;
        })(V2_0_1 = UserEntity.V2_0_1 || (UserEntity.V2_0_1 = {}));
        let V3_0_0;
        (function(V3_0_0) {
            var SCHEMA_URL = V3_0_0.SCHEMA_URL = 'iglu:com.hudl/user_entity/jsonschema/3-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V3_0_0.describe = describe;
        })(V3_0_0 = UserEntity.V3_0_0 || (UserEntity.V3_0_0 = {}));
        let V3_1_0;
        (function(V3_1_0) {
            var SCHEMA_URL = V3_1_0.SCHEMA_URL = 'iglu:com.hudl/user_entity/jsonschema/3-1-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V3_1_0.describe = describe;
        })(V3_1_0 = UserEntity.V3_1_0 || (UserEntity.V3_1_0 = {}));
        let V4_0_0;
        (function(V4_0_0) {
            var SCHEMA_URL = V4_0_0.SCHEMA_URL = 'iglu:com.hudl/user_entity/jsonschema/4-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V4_0_0.describe = describe;
        })(V4_0_0 = UserEntity.V4_0_0 || (UserEntity.V4_0_0 = {}));
        let V4_0_1;
        (function(V4_0_1) {
            var SCHEMA_URL = V4_0_1.SCHEMA_URL = 'iglu:com.hudl/user_entity/jsonschema/4-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V4_0_1.describe = describe;
        })(V4_0_1 = UserEntity.V4_0_1 || (UserEntity.V4_0_1 = {}));
        let V4_0_2;
        (function(V4_0_2) {
            var SCHEMA_URL = V4_0_2.SCHEMA_URL = 'iglu:com.hudl/user_entity/jsonschema/4-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V4_0_2.describe = describe;
        })(V4_0_2 = UserEntity.V4_0_2 || (UserEntity.V4_0_2 = {}));
        let V4_0_3;
        (function(V4_0_3) {
            var SCHEMA_URL = V4_0_3.SCHEMA_URL = 'iglu:com.hudl/user_entity/jsonschema/4-0-3';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V4_0_3.describe = describe;
        })(V4_0_3 = UserEntity.V4_0_3 || (UserEntity.V4_0_3 = {}));
    })(UserEntity = HudlDataSchemas.UserEntity || (HudlDataSchemas.UserEntity = {}));
    let UserOrgEntity;
    (function(UserOrgEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/user_org_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = UserOrgEntity.V1_0_0 || (UserOrgEntity.V1_0_0 = {}));
    })(UserOrgEntity = HudlDataSchemas.UserOrgEntity || (HudlDataSchemas.UserOrgEntity = {}));
    let UserTeamEntity;
    (function(UserTeamEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/user_team_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = UserTeamEntity.V1_0_0 || (UserTeamEntity.V1_0_0 = {}));
    })(UserTeamEntity = HudlDataSchemas.UserTeamEntity || (HudlDataSchemas.UserTeamEntity = {}));
    let VideoEntity;
    (function(VideoEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/video_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = VideoEntity.V1_0_0 || (VideoEntity.V1_0_0 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/video_entity/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = VideoEntity.V2_0_0 || (VideoEntity.V2_0_0 = {}));
        let V2_0_1;
        (function(V2_0_1) {
            var SCHEMA_URL = V2_0_1.SCHEMA_URL = 'iglu:com.hudl/video_entity/jsonschema/2-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_1.describe = describe;
        })(V2_0_1 = VideoEntity.V2_0_1 || (VideoEntity.V2_0_1 = {}));
    })(VideoEntity = HudlDataSchemas.VideoEntity || (HudlDataSchemas.VideoEntity = {}));
    let VideoIntegrationEvent;
    (function(VideoIntegrationEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/video_integration_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = VideoIntegrationEvent.V1_0_0 || (VideoIntegrationEvent.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/video_integration_event/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = VideoIntegrationEvent.V1_0_1 || (VideoIntegrationEvent.V1_0_1 = {}));
        let V1_0_2;
        (function(V1_0_2) {
            var SCHEMA_URL = V1_0_2.SCHEMA_URL = 'iglu:com.hudl/video_integration_event/jsonschema/1-0-2';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_2.describe = describe;
        })(V1_0_2 = VideoIntegrationEvent.V1_0_2 || (VideoIntegrationEvent.V1_0_2 = {}));
        let V1_0_3;
        (function(V1_0_3) {
            var SCHEMA_URL = V1_0_3.SCHEMA_URL = 'iglu:com.hudl/video_integration_event/jsonschema/1-0-3';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_3.describe = describe;
        })(V1_0_3 = VideoIntegrationEvent.V1_0_3 || (VideoIntegrationEvent.V1_0_3 = {}));
        let V2_0_0;
        (function(V2_0_0) {
            var SCHEMA_URL = V2_0_0.SCHEMA_URL = 'iglu:com.hudl/video_integration_event/jsonschema/2-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V2_0_0.describe = describe;
        })(V2_0_0 = VideoIntegrationEvent.V2_0_0 || (VideoIntegrationEvent.V2_0_0 = {}));
    })(VideoIntegrationEvent = HudlDataSchemas.VideoIntegrationEvent || (HudlDataSchemas.VideoIntegrationEvent = {}));
    let VideoPlaybackActivity;
    (function(VideoPlaybackActivity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/video_playback_activity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = VideoPlaybackActivity.V1_0_0 || (VideoPlaybackActivity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/video_playback_activity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = VideoPlaybackActivity.V1_0_1 || (VideoPlaybackActivity.V1_0_1 = {}));
    })(VideoPlaybackActivity = HudlDataSchemas.VideoPlaybackActivity || (HudlDataSchemas.VideoPlaybackActivity = {}));
    let VideoPlaybackHeartbeatEvent;
    (function(VideoPlaybackHeartbeatEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/video_playback_heartbeat_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = VideoPlaybackHeartbeatEvent.V1_0_0 || (VideoPlaybackHeartbeatEvent.V1_0_0 = {}));
    })(VideoPlaybackHeartbeatEvent = HudlDataSchemas.VideoPlaybackHeartbeatEvent || (HudlDataSchemas.VideoPlaybackHeartbeatEvent = {}));
    let VideoViewEvent;
    (function(VideoViewEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/video_view_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = VideoViewEvent.V1_0_0 || (VideoViewEvent.V1_0_0 = {}));
    })(VideoViewEvent = HudlDataSchemas.VideoViewEvent || (HudlDataSchemas.VideoViewEvent = {}));
    let ViewEvent;
    (function(ViewEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/view_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = ViewEvent.V1_0_0 || (ViewEvent.V1_0_0 = {}));
    })(ViewEvent = HudlDataSchemas.ViewEvent || (HudlDataSchemas.ViewEvent = {}));
    let WidgetEntity;
    (function(WidgetEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/widget_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = WidgetEntity.V1_0_0 || (WidgetEntity.V1_0_0 = {}));
    })(WidgetEntity = HudlDataSchemas.WidgetEntity || (HudlDataSchemas.WidgetEntity = {}));
    let WorkflowSessionEntity;
    (function(WorkflowSessionEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/workflow_session_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = WorkflowSessionEntity.V1_0_0 || (WorkflowSessionEntity.V1_0_0 = {}));
    })(WorkflowSessionEntity = HudlDataSchemas.WorkflowSessionEntity || (HudlDataSchemas.WorkflowSessionEntity = {}));
    let WorkflowSessionStartEndEvent;
    (function(WorkflowSessionStartEndEvent) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/workflow_session_start_end_event/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = WorkflowSessionStartEndEvent.V1_0_0 || (WorkflowSessionStartEndEvent.V1_0_0 = {}));
    })(WorkflowSessionStartEndEvent = HudlDataSchemas.WorkflowSessionStartEndEvent || (HudlDataSchemas.WorkflowSessionStartEndEvent = {}));
    let WyscoutReportEntity;
    (function(WyscoutReportEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/wyscout_report_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = WyscoutReportEntity.V1_0_0 || (WyscoutReportEntity.V1_0_0 = {}));
    })(WyscoutReportEntity = HudlDataSchemas.WyscoutReportEntity || (HudlDataSchemas.WyscoutReportEntity = {}));
    let WyscoutUserEntity;
    (function(WyscoutUserEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/wyscout_user_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = WyscoutUserEntity.V1_0_0 || (WyscoutUserEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/wyscout_user_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = WyscoutUserEntity.V1_0_1 || (WyscoutUserEntity.V1_0_1 = {}));
    })(WyscoutUserEntity = HudlDataSchemas.WyscoutUserEntity || (HudlDataSchemas.WyscoutUserEntity = {}));
    let WyscoutUserOrgEntity;
    (function(WyscoutUserOrgEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/wyscout_user_org_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = WyscoutUserOrgEntity.V1_0_0 || (WyscoutUserOrgEntity.V1_0_0 = {}));
    })(WyscoutUserOrgEntity = HudlDataSchemas.WyscoutUserOrgEntity || (HudlDataSchemas.WyscoutUserOrgEntity = {}));
    let WyscoutUserTeamEntity;
    (function(WyscoutUserTeamEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/wyscout_user_team_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = WyscoutUserTeamEntity.V1_0_0 || (WyscoutUserTeamEntity.V1_0_0 = {}));
    })(WyscoutUserTeamEntity = HudlDataSchemas.WyscoutUserTeamEntity || (HudlDataSchemas.WyscoutUserTeamEntity = {}));
    let WyscoutVideoEntity;
    (function(WyscoutVideoEntity) {
        let V1_0_0;
        (function(V1_0_0) {
            var SCHEMA_URL = V1_0_0.SCHEMA_URL = 'iglu:com.hudl/wyscout_video_entity/jsonschema/1-0-0';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_0.describe = describe;
        })(V1_0_0 = WyscoutVideoEntity.V1_0_0 || (WyscoutVideoEntity.V1_0_0 = {}));
        let V1_0_1;
        (function(V1_0_1) {
            var SCHEMA_URL = V1_0_1.SCHEMA_URL = 'iglu:com.hudl/wyscout_video_entity/jsonschema/1-0-1';
            function describe(data) {
                return {
                    schema: SCHEMA_URL,
                    data
                };
            }
            V1_0_1.describe = describe;
        })(V1_0_1 = WyscoutVideoEntity.V1_0_1 || (WyscoutVideoEntity.V1_0_1 = {}));
    })(WyscoutVideoEntity = HudlDataSchemas.WyscoutVideoEntity || (HudlDataSchemas.WyscoutVideoEntity = {}));
})(HudlDataSchemas || (HudlDataSchemas = {}));
export default HudlDataSchemas;

//# sourceMappingURL=HudlDataSchemas.js.map